
import Vue from 'vue'

import { StoreState } from '@/store'

import { blockScroll, enableScroll } from '~/plugins/helper'

export default Vue.extend({
  computed: {
    isShowMenu(): boolean {
      // @ts-ignore
      return (this.$store.state as StoreState).isShowMenu
    }
  },
  methods: {
    handleClick(): void {
      // @ts-ignore
      this.$store.commit('SET_MENU', !this.$store.state.isShowMenu)
      if (!this.isShowMenu) {
        enableScroll()
      } else {
        blockScroll(window.scrollY)
      }
    }
  }
})
